import React from "react";
import { Button } from "components/ui";
import OriAvatar from "components/ori/OriAvatar";
import { useTranslation } from "lib/i18n/use-translation";
import AssessmentUpliftHeader from "./AssessmentUpliftHeader";
import styles from "./AssessmentEndUplift.module.scss";

export interface AssessmentEndUpliftProps {
  firstName?: string | null;
  hasCompanyQuestions?: boolean;
  onContinue?: () => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
  onBack?: () => void;
}

const AssessmentEndUplift: React.FC<AssessmentEndUpliftProps> = ({
  firstName,
  hasCompanyQuestions = false,
  onContinue,
  onSubmit,
  isSubmitting = false,
  onBack,
}) => {
  const { t } = useTranslation(["assessment"]);

  return (
    <div className={styles.container} data-testid="assessment-end-uplift">
      <AssessmentUpliftHeader onBack={onBack} />

      <div className={styles.body}>
        <div className={styles.content}>
          <div className={styles["ori-row"]}>
            <OriAvatar size={48} />
            <p className={styles["ori-name"]}>{t("assessment:uplift.oriName")}</p>
          </div>

          <h1 className={styles.heading}>
            {firstName
              ? t("assessment:end.headingNamed", { name: firstName })
              : t("assessment:end.heading")}
          </h1>

          <p className={styles.paragraph}>{t("assessment:end.body1")}</p>
          <p className={styles.paragraph}>{t("assessment:end.body2")}</p>
          <p className={styles.paragraph}>{t("assessment:end.body3")}</p>
        </div>
      </div>

      <div className={styles.footer}>
        <div className={styles["footer-content"]}>
          {hasCompanyQuestions && onContinue && (
            <Button
              variant="enclosed-primary"
              monochromeColour="black"
              className={styles["continue-button"]}
              onClick={onContinue}
            >
              {t("assessment:end.continue")}
            </Button>
          )}
          <Button
            variant="enclosed-secondary"
            monochromeColour="black"
            className={styles["submit-button"]}
            onClick={onSubmit}
            loading={isSubmitting}
            disabled={isSubmitting}
          >
            {t("assessment:end.submit")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AssessmentEndUplift;
